import { movies, siteInfo } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function AllContent() {
  const allMovies = movies.slice(0, 12);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            全部影视
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {siteInfo.description}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-5">
          {allMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} size="sm" />
          ))}
        </div>
      </div>
    </section>
  );
}